<template>
    <div class="border border-gray-2 rounded-lg overflow-hidden mb-4" @click="clickPurchase()">
        <div class="flex p-2 bg-white">
            <div class="w-1/3">
                <div class="campaign-image rounded-md" :style="{'background-image': `url('${purchase.fullImageUrl}')`}"></div>
            </div>
            <div class="w-2/3 pl-4">
                <div class="campaign-name text-20 text-blue-1">{{purchase.name}}</div>
                <div class="text-gray-1">
                    <img class="inline mr-1 h-4" src="@/assets/icon/ic-time.svg" alt=""/>
                    <a>{{lbl.history.expired_date}}</a>{{FilterDateFormat(purchase.voucherExpireDate)}}
                </div>
                <div v-if="isTransferpoint && purchase.info1" class="text-gray-1 flex gap-1 break-all">
                    <div class="flex-shrink-0">transaction id :</div>
                    <div>{{ purchase.info1 }}</div>
                </div>
                <div class="flex">
                    <div class="w-2/3">
                        <div class="flex text-22" v-if="isShowPurchaseMsg && !isShowDelivery" >
                            <img v-if="(purchase.type == campaignType.Free || purchase.type == campaignType.Deal || purchase.type == campaignType.PayWithPoint || purchase.type == campaignType.Privilege2) && isActive"
                                class="inline my-auto ml-0 mr-2 h-4"
                                src="@/assets/icon/ic-qr-code.svg" alt=""/>
                            <img v-else-if="(purchase.type == campaignType.Free || purchase.type == campaignType.Deal || purchase.type == campaignType.PayWithPoint)"
                                class="inline my-auto ml-0 mr-2 h-4"
                                src="@/assets/icon/ic-qr-code-expire.svg" alt=""/>
                            <div v-if="(purchase.type == campaignType.Free || purchase.type == campaignType.Deal || purchase.type == campaignType.Interface || purchase.type == campaignType.PayWithPoint || purchase.type == campaignType.Privilege2) && isActive || (purchase.website && purchase.website.indexOf('linesticker') > 0)"
                                class="text-blue-1 underline"
                                v-html="purchaseMessage"></div>
                            <div v-else-if="(purchase.type == campaignType.Free || purchase.type == campaignType.Deal || purchase.type == campaignType.Interface || purchase.type == campaignType.PayWithPoint)"
                                class="text-gray-2"
                                v-html="purchaseMessage"></div>
                        </div>
                    </div>
                    <div v-if="!isShowDelivery && isPrivilage2" class="flex-none text-right text-red-2 text-20">{{ getPrivilageTxt() }}</div>
                    <div v-if="!isShowDelivery && !isPrivilage2" class="flex-none text-right text-red-2 text-20">{{getPointMessage()}}</div>
                </div>
                <div v-if="isShowDelivery" class=" text-16 text-a-gray-666666">สถานะ : {{deliveryMessage}}</div>
                <div v-if="isShipped" class=" text-16 text-a-gray-666666"> พัสดุเลขที่ <a class="text-a-blue-0069a8">{{purchase.parcelNo}}</a></div>
                <div v-if="isShowPrivilegeMessage" class=" text-16 text-a-gray-666666" v-html="privilegeMessage"></div>
                <div v-if="isShowDelivery && isPrivilage2" class="flex justify-end text-right text-red-2 text-20">{{getPrivilageTxt()}}</div>
                <div v-if="isShowDelivery && !isPrivilage2" class="flex justify-end text-right text-red-2 text-20">{{getPointMessage()}}</div>
            </div>
        </div>
    </div>
</template>
<script>
import Util from '@/helper/Utility.js';
import { CampaignType } from '@/helper/StaticValue.js';
import LocaleMixin from '@/mixin/LocaleMixin.js';

/**
 * @event onClickPurchase
 */
export default {
    name: 'HistoryItem',
    mixins: [LocaleMixin],
    props: {
        purchase: { type: Object, required: true },
    },
    data: function() {
        return {
            deliveryMessage: '',
            isActive: false,
            isShipped: false,
            isShowAdsMessage: false,
            isShowDelivery: false,
            isShowPrivilegeMessage: true,
            isWinner: false,
            privilegeMessage: this.purchase.privilegeMessage,
            purchaseMessage: '',
            type: 'purchase', //draw, interface, purchase.
            campaignType: CampaignType,
            isPrivilage2: false,
            campaignPrivilege2: '',
            isTransferpoint: false,
        };
    },
    created: function() {
        this.initialPurchase();
    },
    computed: {
        isShowPurchaseMsg: function() {
            return this.type == 'purchase' || this.type == 'draw' || this.type == 'interface';
        },
    },
    methods: {
        getPointMessage: function () {
            let pointType = this.purchase.pointType == 'get' ? "" : "-";
            let pointUnit = this.lbl.history.point + (this.purchase.pointPerUnit > 1 && this.localeCode == 1033 ? 's' : '');
            return pointType + " " + this.FilterNumberFormat(this.purchase.pointPerUnit) + " " + pointUnit;
        },
        initialPurchase: function () {
            if (this.purchase.privilegeMessageFormat && this.purchase.privilegeMessageFormat.toLowerCase() === 'html') {
                this.isShowPrivilegeMessage = false;
            }

            //purchase message.
            switch(this.purchase.type) {
                case CampaignType.Draw:
                    this.isDraw = true;
                    this.type = 'draw';
                    this.purchaseMessage = this.lbl.purchase.not_draw1 + (this.lbl.purchase.not_draw2 ? ' ' + this.lbl.purchase.not_draw2 : '');

                    if (this.purchase.hasWinner) {
                        this.isActive = true;
                        if (this.purchase.isWinner) {
                            this.isWinner = true;
                            this.purchaseMessage = this.lbl.purchase.draw_winner1 + (this.lbl.purchase.draw_winner2 ? ' ' + this.lbl.purchase.draw_winner2 : '');

                            if (this.isShowAdsMessage && this.purchase.adsMessage) {
                                this.purchaseMessage += "<br>" + this.purchase.adsMessage;
                            }
                        } else {
                            this.isWinner = false;
                            this.purchaseMessage = this.lbl.purchase.draw_not_win1 + (this.lbl.purchase.draw_not_win2 ? ' ' + this.lbl.purchase.draw_not_win2 : '');
                        }
                    }

                    this.isShowPrivilegeMessage = false;
                    break;
                case CampaignType.Buy:
                case CampaignType.Free:
                case CampaignType.Deal:
                    if (this.purchase.voucherExpireDate < this.purchase.currentDate){
                        this.purchaseMessage = this.lbl.purchase.code_expired;
                    } else {
                        if (this.purchase.serial == "XXXXXXX") {
                            this.isActive = true;
                            this.purchaseMessage = this.lbl.purchase.is_Used;
                        } else {
                            if (this.purchase.isUsed || this.purchase.serial == "XXXXXXX") {
                                this.isActive = true;
                                // (this.purchase.isUsed == true && this.purchase.serial == "XXXXXXX" || this.purchase.isUsed == true && this.purchase.minutesValidAfterUsed == '0')
                                this.purchaseMessage = this.lbl.purchase.is_Used;
                            } else {
                                this.isActive = true;
                                this.purchaseMessage = this.lbl.purchase.show_code;
                            }
                        }
                    }
                    break;
                case CampaignType.PayWithPoint:
                    if (this.purchase.voucherExpireDate < this.purchase.currentDate){
                        this.purchaseMessage = this.lbl.purchase.code_expired;
                    } else {
                        if (this.purchase.serial == "XXXXXXX") {
                            if (this.purchase.isUsed) {
                                this.isActive = false;
                                this.purchaseMessage = this.lbl.purchase.is_Used;
                            } else {
                                this.isActive = false;
                                this.purchaseMessage = this.lbl.purchase.code_expired;
                            }
                        } else {
                            if (this.purchase.isUsed) {
                                this.isActive = true;
                                this.purchaseMessage = this.lbl.purchase.is_Used;
                            } else {
                                this.isActive = true;
                                this.purchaseMessage = this.lbl.purchase.show_code;
                            }
                        }
                    }
                    break;
                case CampaignType.Interface:
                    this.type = 'interface';
                    if (this.purchase.expireIn && this.purchase.expireIn < 0) {
                        this.purchaseMessage = this.lbl.purchase.code_expired;
                        this.isShowPrivilegeMessage = false;
                    } else {
                        if (this.purchase.pointType == "get") {
                            this.purchaseMessage = this.lbl.purchase.interface_get;
                        }
                        else {
                            if (this.purchase.website && this.purchase.website.indexOf('linesticker') > 0){
                                return this.purchaseMessage = this.lbl.purchase.interface_linesticker
                            }
                            else if (this.purchase.website && this.purchase.website.indexOf('starbucks') > 0){
                                this.isActive = true;
                                return this.purchaseMessage = this.lbl.purchase.interface_use;
                            }
                            else if (this.purchase.website && this.purchase.website.indexOf('/wondd/') > 0){
                                this.isActive = true;
                                this.isShowPrivilegeMessage = false;
                                return this.purchaseMessage = this.lbl.purchase.interface_use;
                            }
                            else if (this.purchase.website && this.purchase.website.indexOf('bangchak') > 0){
                                return this.isTransferpoint = true;
                            }
                            else {
                                this.isActive = false;
                                this.isShowPrivilegeMessage = false;
                            }
                        }
                    }
                    break;
                case CampaignType.Privilege2:
                    this.isPrivilage2 = true;

                    if (this.purchase.info4) {
                        this.campaignPrivilege2 = JSON.parse(this.purchase.info4);
                        console.log(this.campaignPrivilege2)

                        if (this.purchase.isUsed || this.purchase.serial == "XXXXXXX") {
                            this.isActive = true;
                            this.purchaseMessage = this.lbl.purchase.is_Used;
                        } else {
                            this.isActive = true;
                            this.purchaseMessage = this.lbl.purchase.show_code;
                        }
                    }
                    break;
            }
            //delivery.
            if (this.purchase.delivered === true) {
                this.isShowDelivery = true;
                if (this.purchase.type === CampaignType.Draw) {
                    if (!this.purchase.hasWinner) {
                        this.isShowDelivery = false;
                    } else {
                        if (!this.purchase.isWinner)
                            this.isShowDelivery = false;
                    }
                }

                if (this.purchase.isShipped) {
                    this.isShipped = true;
                    this.deliveryMessage = this.lbl.purchase.shipped;
                } else {
                    this.isShipped = false;
                    this.deliveryMessage = this.lbl.purchase.delivery;
                }
            }

            this.deliveryMessage = Util.newLineToBr(this.deliveryMessage);
            this.privilegeMessage = Util.newLineToBr(this.privilegeMessage);
            this.purchaseMessage = Util.newLineToBr(this.purchaseMessage);
        },

        clickPurchase: function() {
            this.$emit('onClickPurchase', this.purchase);
        },

        getPrivilageTxt: function () {
            if (this.campaignPrivilege2) {
                let pointTypeTxt = '-';

                let pointUnit = this.localeCode === 1033 && this.campaignPrivilege2.MaximumPartialPoints > 1
                            ? this.lbl.detail.point_unit + 's'
                            : this.lbl.detail.point_unit;

                return `${pointTypeTxt} ${'฿'}${this.FilterNumberFormat(this.campaignPrivilege2.MaximumPartialPrice)} ${'+'} ${this.FilterNumberFormat(this.campaignPrivilege2.MaximumPartialPoints)} ${pointUnit}`;
            } else {
                return '';
            }
        }
    }
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/text.scss";
    @import "@/style/base/image.scss";
    .campaign-name {
        height: 48px;
        @extend %ellipsis-2;
    }
    .campaign-image {
        @include boxRatio($ratio: 66.66%);
    }
</style>
